import { render } from "./IconPerson.vue?vue&type=template&id=59fa6beb"
import script from "./IconPerson.vue?vue&type=script&lang=ts"
export * from "./IconPerson.vue?vue&type=script&lang=ts"
script.render = render

export default script